import Link from 'next/link';
import { Icon } from '@/components/ui/icon';
import GlossaryCategoryTag from './GlossaryCategoryTag';

const GlossaryTermCard = ({ term, href }) => {
  const primaryCategory = term.categories?.[0];

  return (
    <Link
      href={href}
      className="group border-grey-200 hover:border-grey-300 flex flex-col gap-3 rounded-2xl border bg-white p-6 transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(0,0,0,0.08)]"
    >
      <div className="flex items-start justify-between gap-3">
        <span className="text-[17px] leading-tight font-semibold">{term.title}</span>
        {primaryCategory && <GlossaryCategoryTag name={primaryCategory.name} color={primaryCategory.color} />}
      </div>

      {term.shortDescription && (
        <p className="text-grey-600 line-clamp-3 text-sm leading-relaxed">{term.shortDescription}</p>
      )}

      <span className="text-brand-500 mt-auto inline-flex items-center gap-1 text-sm font-medium transition-all group-hover:gap-2">
        Přečíst
        <Icon type="chevronRight" width={14} height={14} />
      </span>
    </Link>
  );
};

export default GlossaryTermCard;
